import { styled } from '../../lib/imports';

export const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;
